import { useCallback, useEffect, useState } from 'react';
import { getAppStoreLinks } from '../services/appStoreLinks';

export default function useAppStoreLinks() {
  const [state, setState] = useState({ links: [], loading: true, error: false });
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt((value) => value + 1), []);

  useEffect(() => {
    let active = true;
    const load = async () => {
      if (document.visibilityState === 'hidden') return;
      try {
        const links = await getAppStoreLinks({ fresh: attempt > 0 });
        if (active) setState({ links, loading: false, error: false });
      } catch {
        if (active) setState({ links: [], loading: false, error: true });
      }
    };
    load();
    const interval = setInterval(load, 60000);
    window.addEventListener('focus', load);
    document.addEventListener('visibilitychange', load);
    return () => {
      active = false;
      clearInterval(interval);
      window.removeEventListener('focus', load);
      document.removeEventListener('visibilitychange', load);
    };
  }, [attempt]);

  return { ...state, retry };
}
